<template>
  <v-container class="ma-0 pa-0 pb-8">
    <v-row class="pt-10 px-8 pb-12">
      <strong>Filtros</strong>
      <v-spacer></v-spacer>
      <v-btn small class="elevation-0" style="border:1px solid #dddddd;" @click="removeFilter">
        <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
      </v-btn>

      <!-- Influencer -->
      <v-autocomplete
        v-model="model.influencer_id"
        :items="influencerItems"
        :loading="isLoadingInfluencers"
        :search-input.sync="searchInfluencers"
        hide-no-data
        item-value="id"
        item-text="name"
        label="Influencer"
        placeholder="Escribe para buscar"
        clearable
      >
        <template v-slot:item="{ item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs">
            <v-list-item-content>
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-subtitle v-if="item.extra">{{ item.extra }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-autocomplete>

      <v-text-field label="Título" v-model="model.title" />
      <v-text-field label="Descripción" v-model="model.description" />
    </v-row>

    <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
      <v-list-item dark link @click="apply">
        <v-list-item-content>
          <strong>Filtrar ({{ counter }})</strong>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'InfluencerFilesFilter',
  data: () => ({
    model: {
      influencer_id: '',
      title: '',
      description: '',
    },
    searchInfluencers: '',
    isLoadingInfluencers: false,
    influencers: [],
  }),
  computed: {
    influencerItems () {
      const list = this.influencers || []
      return list.map(function (i) {
        return {
          id: i.id,
          name: (i.social_networks && i.social_networks.instagram) ? i.social_networks.instagram : (i.name || ('#' + i.id)),
          extra: i.name && i.last ? (i.name + ' ' + i.last) : (i.name || '')
        }
      })
    },
    counter () {
      var c = 0
      var m = this.model
      if (m.influencer_id) c++
      if (m.title) c++
      if (m.description) c++
      return c
    },
  },
  watch: {
    searchInfluencers (val) {
      if (this.isLoadingInfluencers) return
      this.isLoadingInfluencers = true
      const base = process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/influencer/search?'
      const url  = base + 'filter[social_networks]=' + encodeURIComponent(val || '')
      axios.get(url)
        .then(res => {
          this.influencers = (res && res.data && res.data.data) ? res.data.data : []
        })
        .finally(() => { this.isLoadingInfluencers = false })
    }
  },
  created () {
    const saved = localStorage.getItem('selectorFiltersInfluencerFiles')
    if (saved) {
      try { this.model = JSON.parse(saved) } catch (e) {}
    }
  },
  methods: {
    apply () {
      var qs = ''
      var m = this.model
      if (m.influencer_id) qs += '&filter[influencer_id]=' + encodeURIComponent(m.influencer_id)
      if (m.title)        qs += '&filter[title]=' + encodeURIComponent(m.title)
      if (m.description)  qs += '&filter[description]=' + encodeURIComponent(m.description)

      localStorage.setItem('selectorFiltersInfluencerFiles', JSON.stringify(this.model))
      localStorage.setItem('filtersInfluencerFiles', JSON.stringify(qs.slice(1)))
      localStorage.setItem('filtersInfluencerFilesLength', String(this.counter))

      this.$nextTick(() => this.$emit('apply', false))
    },
    removeFilter () {
      this.model = { influencer_id: '', title: '', description: '' }
      localStorage.removeItem('selectorFiltersInfluencerFiles')
      localStorage.removeItem('filtersInfluencerFiles')
      localStorage.removeItem('filtersInfluencerFilesLength')
      this.$nextTick(() => this.$emit('apply', false))
    }
  }
}
</script>

<style>
.v-text-field { padding-top:10px; margin-top:0px; }
</style>
